module.exports = require("./jmc.js");